export default "__VITE_ASSET__BrqfgAfL__"